(function($) {

	'use strict';

	var ProductCampaigns = function(element, options) {
		this.$element 											= $(element);
		this.options 												= options;
	};

	ProductCampaigns.DEFAULTS = {
		productCampaignSku: '',
		seeMore: ''
	};

	ProductCampaigns.prototype.fetchCampaigns = function () {

		var that = this;
		
		return $.get("/product/campaigns?sku=" + this.options.productCampaignSku);
	};

	ProductCampaigns.prototype.getTemplate = function() {
		var html = "";
		var that = this;
		var campaigns = this.campaigns.slice(0,3);
		
		campaigns.forEach( function(item) {
			if(item.landingpage !== null || item.landingpage !== "") {
				html += "<li class=\"campaign-item\"><i class=\"icon-tag\"></i>" + item.name + "<a href=\"" + item.landingpage + "\">"+ that.options.seeMore +"</a></li>";
			}
		});

		return html;
	};

	ProductCampaigns.prototype.render = function() {
		if(!this.campaigns.length){
			return false;
		}
		var $content = this.$element.find(".list-campaigns");
		var html = this.getTemplate();
		$content.html(html);
		this.$element.removeClass('hide');
	};

	ProductCampaigns.prototype.init = function() {
		var that = this;
		var promise = this.fetchCampaigns();
		promise.done(function(result) {
			that.campaigns = result.campaigns || [];
			that.render();
		});
	};


	$.fn.campaigns = function(option, args) {
		return this.each(function() {
			var $this = $(this);
			var $data = $this.data("dft.product-campaigns");
			var options = $.extend({}, ProductCampaigns.DEFAULTS, $this.data(), typeof option == 'object' && option);
			if (!$data) $this.data('dft.product-campaigns', ($data = new ProductCampaigns(this, options)));
	    if (typeof option == 'string') $data[option](args);
	    $data.init();
	  });

	};

	$("[data-product-campaign-sku]").campaigns();

})(jQuery);